// extracted by mini-css-extract-plugin
export default {"flexContainer":"ProductRewards_flexContainer__vxaVy","switchContainer":"ProductRewards_switchContainer__rupnM"};